import * as React from "react";
import { Box, display } from "@mui/system";
import {
  Typography,
  Button,
  Stack,
  Grid,
  Divider,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Tab,
  Tabs,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import axios from "../../axios-config";
import { useEffect, useState } from "react";

import { useSnackbar } from "notistack";
import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { authActions } from "../../store/auth";
import "../../App.css";

import { useTranslation } from "react-i18next";

import PartnerRequests from "./PartnerRequests";
import BoxContainer from "../../common/BoxContainer/BoxContainer";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
//ICONS
import AddIcon from "@mui/icons-material/Add";
import ConsoleHelper from "../../utils/ConsoleHelper";
import InviteUserForm from "./InviteUserForm";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import CurrencySelect from "./CurrencySelect";

import { grey } from "@mui/material/colors";
import Billing from "./Billing";
import SettingsHeader from "./SettingsHeader";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const OrganizationSettings = ({ changeColor }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  let dayjs = require("dayjs");
  var relativeTime = require("dayjs/plugin/relativeTime");
  dayjs.extend(relativeTime);

  useEffect(() => {
    return () => {
      console.log("Navigation bar unmounting");
    };
  }, []);
  const [organizationData, setOrganizationData] = useState({});

  const [editedOrganizationData, setEditedOrganizationData] = useState({
    name: "",
    legalName: "",
    taxIdentifier: "",
    address: "",
    state: "",
    city: "",
    postalCode: "",
    currency: "",
  });
  const [isEdited, setIsEdited] = useState(false);

  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  // document.body.style.backgroundColor = "white";
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await axios.get(`/organizations`);
        const isSuccessful = response.status === 200 || response.status === 201;
        if (isSuccessful) {
          ConsoleHelper(response.data);
          setOrganizationData(response.data);
          setEditedOrganizationData(response.data);
          setLoading(false);
          if (response.data.organizationSubscription) {
            dispatch(
              authActions.updateSubscription({
                subscriptionType:
                  response.data.organizationSubscription.subscriptionType,
                endDate: response.data.organizationSubscription.endDate,
              })
            );
            localStorage.setItem(
              "subscriptionType",
              response.data.organizationSubscription.subscriptionType
            );
            localStorage.setItem(
              "endDate",
              response.data.organizationSubscription.endDate
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchOrganizations();
  }, []);

  useEffect(() => {
    validate();
  }, [editedOrganizationData]);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const result = await axios.get("/app-billing/customer");
        if (result.status === 200) {
          console.log(result.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchCustomer();
    // const fetchSubscription = async () => {
    //   try {
    //     const result = await axios.get("/app-billing/subscriptions");
    //     if (result.status === 200) {
    //       console.log(result.data);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    // fetchSubscription();
  }, []);

  const validate = () => {
    // console.log(organizationData.name, editedOrganizationData.name)
    setIsEdited(false);
    // if (loading || editedOrganizationData.name.length < 1)
    //     return;

    if (organizationData.name !== editedOrganizationData.name) {
      setIsEdited(true);
    }
    if (organizationData.legalName !== editedOrganizationData.legalName) {
      setIsEdited(true);
    }
    if (
      organizationData.taxIdentifier !== editedOrganizationData.taxIdentifier
    ) {
      setIsEdited(true);
    }
    if (organizationData.address !== editedOrganizationData.address) {
      setIsEdited(true);
    }
    if (organizationData.state !== editedOrganizationData.state) {
      setIsEdited(true);
    }
    if (organizationData.city !== editedOrganizationData.city) {
      setIsEdited(true);
    }
    if (organizationData.postalCode !== editedOrganizationData.postalCode) {
      setIsEdited(true);
    }
    if (organizationData.currency !== editedOrganizationData.currency) {
      setIsEdited(true);
    }
    if (
      editedOrganizationData.currency === "" ||
      editedOrganizationData.currency === null
    ) {
      setIsEdited(false);
    }
  };

  const handleInput = (event) => {
    setEditedOrganizationData((prevState) => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };
  const handleSave = async () => {
    try {
      const response = await axios.patch(
        `/organizations/settings`,
        editedOrganizationData
      );
      if (response.status === 200 || response.status === 201) {
        setOrganizationData({ ...editedOrganizationData });
        setIsEdited(false);
        enqueueSnackbar("Settings updated succesfully", { variant: "success" });
        dispatch(
          authActions.updateAuthOrganization({
            name: response.data.name,
            currency: response.data.currency,
          })
        );
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onCurrencyChange = (currency) => {
    ConsoleHelper(currency, "currency");
    setEditedOrganizationData((prevState) => ({
      ...prevState,
      currency: currency,
    }));
  };

  if (loading)
    return (
      <>
        <Typography>Loading...</Typography>
      </>
    );

  return (
    <>
      <Box className={"container mainContainer docsContainer "}>
        <Box
          sx={{
            minHeight: "100vh",
            background: "#fff", // updated to white background
            py: 4,
            px: { xs: 2, md: 4 },
          }}
        >
          <Container maxWidth="lg">
            <div className="headerPush"></div>
            {/* BACK BUTTON */}
            <SettingsHeader title={t("Organization settings")} />
            <Stack
              direction={"row"}
              alignItems={"flex-start"}
              spacing={1}
            ></Stack>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <BoxContainer sx={{ mb: 2 }}>
                  <Stack spacing={2} alignItems={"flex-start"}>
                    <Typography variant={"h6"} color={grey[800]}>
                      {t("Organization ")}
                    </Typography>
                    <Stack
                      width={"100%"}
                      spacing={2}
                      alignItems={"flex-start"}
                      direction={"row"}
                    >
                      <TextField
                        fullWidth
                        value={editedOrganizationData.name}
                        name={"name"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("Organization name")}
                      />
                    </Stack>
                    <Stack
                      width={"100%"}
                      spacing={2}
                      alignItems={"flex-start"}
                      direction={"row"}
                    >
                      <TextField
                        fullWidth
                        value={editedOrganizationData.legalName}
                        name={"legalName"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("Legal name")}
                      />
                      <TextField
                        fullWidth
                        value={editedOrganizationData.taxIdentifier}
                        name={"taxIdentifier"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("Tax identifier")}
                      />
                    </Stack>
                    <Stack
                      width={"100%"}
                      spacing={2}
                      alignItems={"flex-start"}
                      direction={"row"}
                    >
                      <TextField
                        fullWidth
                        value={editedOrganizationData.address}
                        name={"address"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("Address")}
                      />
                      <TextField
                        fullWidth
                        value={editedOrganizationData.state}
                        name={"state"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("State")}
                      />
                    </Stack>
                    <Stack
                      width={"100%"}
                      spacing={2}
                      alignItems={"flex-start"}
                      direction={"row"}
                    >
                      <TextField
                        fullWidth
                        value={editedOrganizationData.city}
                        name={"city"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("City")}
                      />
                      <TextField
                        fullWidth
                        value={editedOrganizationData.postalCode}
                        name={"postalCode"}
                        onChange={handleInput}
                        variant={"filled"}
                        label={t("Postal code")}
                      />
                    </Stack>
                    {/* <Typography variant={'overline'} color={'darkGrey.main'} textTransform={'uppercase'}>{t("Currency and Region ")}</Typography> */}

                    <CurrencySelect
                      selectedCurrency={editedOrganizationData.currency}
                      onCurrencyChange={onCurrencyChange}
                    />
                    <Button
                      variant={"contained"}
                      disabled={!isEdited}
                      onClick={handleSave}
                    >
                      {t("Save")}
                    </Button>
                  </Stack>
                </BoxContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <BoxContainer>
                  <PartnerRequests currentOrganization={organizationData} />
                </BoxContainer>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default OrganizationSettings;
